import React from 'react'
import { capitalize } from 'lodash'
import { CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'
import StatusPill from '@Components/StatusPills/StatusPill'
import './index.scss'

interface CatalogTransferStatusPillProps {
    transfer: CatalogTransferView
    canReviewActions?: boolean
}

const getStatusPillText = (transfer: CatalogTransferView, canReviewActions?: boolean) => {
    if (transfer.catalogTransferStatus === 'CREATING') {
        return 'Draft'
    }

    if (canReviewActions) {
        return 'Awaiting Your Decision'
    }

    return capitalize(transfer.catalogTransferStatus)
}

const getStatusPillColor = (statusText: string) => {
    if (statusText === 'Approved' || statusText === 'Complete' || statusText === 'Rejected') {
        return 'white'
    }

    return 'gray'
}

const CatalogTransferStatusPill = ({ transfer, canReviewActions }: CatalogTransferStatusPillProps) => {
    const statusPillText = getStatusPillText(transfer, canReviewActions)

    return <StatusPill text={statusPillText} color={getStatusPillColor(statusPillText)} />
}

export default CatalogTransferStatusPill
